"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledText = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _localization = require("@lt/localization");

var _userflow = require("../../icons-react/userflow");

var _facilities = require("../../icons-react/facilities");

var _symbols = require("../../constants/symbols");

var _userflow2 = require("../../utils/userflow");

var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));

var _LabelList = require("../Label/LabelList");

var _index = require("../../proptypes/hotel/index");

var _WarningPlacesEnd = _interopRequireDefault(require("../WarningPlacesEnd"));

var _excluded = ["pricePerNight", "operator", "extras", "ltExtras", "included", "availability", "labels", "isHotelOnly", "isMobile"];

var HotelOfferInfo = function HotelOfferInfo(_ref) {
  var pricePerNight = _ref.pricePerNight,
      operator = _ref.operator,
      extras = _ref.extras,
      ltExtras = _ref.ltExtras,
      included = _ref.included,
      availability = _ref.availability,
      labels = _ref.labels,
      isHotelOnly = _ref.isHotelOnly,
      isMobile = _ref.isMobile,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var oldPrice = (0, _get2["default"])(extras, 'previous_price');
  var cheapest = (0, _get2["default"])(extras, 'best_price') && false; // TODO: возможно чот не так с бэка приходит

  var cancellationPolicy = (0, _get2["default"])(extras, 'cancellation_policy');
  var hasLtExtras = !(0, _isEmpty2["default"])(ltExtras);

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  var _useCurrency = (0, _localization.useCurrency)(),
      code = _useCurrency.code;

  var maxLabels = 3;
  var freeCancellation = (0, _userflow2.isFreeCancellation)(cancellationPolicy);
  if (freeCancellation) maxLabels -= 1;
  var filteredLabels = labels === null || labels === void 0 ? void 0 : labels.filter(function (label) {
    return label.context.hotel === 3;
  });
  return /*#__PURE__*/_react["default"].createElement(StyledHotelOfferInfo, rest, oldPrice && /*#__PURE__*/_react["default"].createElement(StyledPriceBrekdownRow, null, /*#__PURE__*/_react["default"].createElement(StyledHotPriceIconWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledHotPriceIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledOldPrice, {
    value: oldPrice,
    currencyCode: code
  })), /*#__PURE__*/_react["default"].createElement(StyledPriceBrekdownRow, null, pricePerNight > 0 && /*#__PURE__*/_react["default"].createElement(_StyledStyledNightPriceTag, {
    $_css: hasLtExtras || availability ? 5 : 0
  }, /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: pricePerNight,
    currencyCode: code
  }), _symbols.SLASH, _symbols.MOON, cheapest && /*#__PURE__*/_react["default"].createElement(StyledLikeIcon, null)), hasLtExtras && /*#__PURE__*/_react["default"].createElement(StyledGiftIcon, {
    "data-offer-extras": JSON.stringify(ltExtras)
  })), /*#__PURE__*/_react["default"].createElement(StyledWarningPlacesEnd, {
    flight: availability.flight,
    hotel: availability.hotel,
    isHotelOnly: isHotelOnly
  }), /*#__PURE__*/_react["default"].createElement(StyledLabelList, {
    labels: filteredLabels,
    maxLabels: maxLabels,
    isSmall: true,
    isMobile: isMobile
  }), freeCancellation && /*#__PURE__*/_react["default"].createElement(StyledFreeCancellationLabel, null, /*#__PURE__*/_react["default"].createElement(StyledFreeCancelIcon, null), t('hotelcard.tag.free_cancellation')), !isHotelOnly ? /*#__PURE__*/_react["default"].createElement(StyledOperator, null, operator) : null, !(0, _isEmpty2["default"])(included) && /*#__PURE__*/_react["default"].createElement(StyledIncluded, null, included.map(function (item) {
    return String(item.name).toLowerCase();
  }).join('\n')));
};

HotelOfferInfo.defaultProps = {
  included: null,
  extras: null,
  labels: []
};
HotelOfferInfo.propTypes = {
  operator: _propTypes["default"].string.isRequired,
  pricePerNight: _propTypes["default"].number.isRequired,
  availability: _index.AvailabilityPropTypes.isRequired,
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  included: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    code_name: _propTypes["default"].string.isRequired
  }).isRequired),
  extras: _propTypes["default"].shape({
    previous_price: _propTypes["default"].number,
    best_price: _propTypes["default"].bool,
    cancellation_policy: _propTypes["default"].shape({
      kind: _propTypes["default"].string.isRequired,
      description: _propTypes["default"].string.isRequired
    })
  }),
  ltExtras: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
    header: _propTypes["default"].string,
    description: _propTypes["default"].string
  }))
};
var StyledWarningPlacesEnd = (0, _styledComponents["default"])(_WarningPlacesEnd["default"]).withConfig({
  displayName: "HotelOfferInfo__StyledWarningPlacesEnd",
  componentId: "sc-oi8hjh-0"
})(["font-size:12px;margin-bottom:4px;"]);
var StyledOldPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelOfferInfo__StyledOldPrice",
  componentId: "sc-oi8hjh-1"
})(["", " color:", ";text-decoration:line-through;"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.monza;
});

var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledText",
  componentId: "sc-oi8hjh-2"
})(["display:flex;align-items:center;text-align:center;", " color:", ";"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.greyLight;
});

exports.StyledText = StyledText;
var StyledIncluded = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelOfferInfo__StyledIncluded",
  componentId: "sc-oi8hjh-3"
})(["white-space:pre;text-align:center;"]);
var StyledPriceBrekdownRow = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelOfferInfo__StyledPriceBrekdownRow",
  componentId: "sc-oi8hjh-4"
})(["line-height:16px;"]);
var StyledOperator = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelOfferInfo__StyledOperator",
  componentId: "sc-oi8hjh-5"
})(["margin-top:12px;"]);

var StyledHotelOfferInfo = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledHotelOfferInfo",
  componentId: "sc-oi8hjh-6"
})(["display:flex;width:100%;flex-direction:column;justify-content:center;align-items:center;"]);

var StyledNightPriceTag = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledNightPriceTag",
  componentId: "sc-oi8hjh-7"
})(["display:flex;align-items:center;"]);

var _StyledStyledNightPriceTag = (0, _styledComponents["default"])(StyledNightPriceTag).withConfig({
  displayName: "HotelOfferInfo___StyledStyledNightPriceTag",
  componentId: "sc-oi8hjh-8"
})(["margin-right:", "px;"], function (p) {
  return p.$_css;
});

var StyledHotPriceIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledHotPriceIconWrapper",
  componentId: "sc-oi8hjh-9"
})(["position:relative;top:1px;margin-right:3px;"]);

var StyledHotPriceIcon = (0, _styledComponents["default"])(_userflow.HotPriceCircle).withConfig({
  displayName: "HotelOfferInfo__StyledHotPriceIcon",
  componentId: "sc-oi8hjh-10"
})(["height:11px;"]);
var StyledGiftIcon = (0, _styledComponents["default"])(_facilities.Gift).withConfig({
  displayName: "HotelOfferInfo__StyledGiftIcon",
  componentId: "sc-oi8hjh-11"
})(["position:relative;top:-0.5px;width:16px;height:16px;& .gift_svg__gift-icon-body{fill:", ";}& .gift_svg__gift-icon-border{fill:", ";}& .gift_svg__gift-icon-bow{stroke:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.yellowBase;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackLight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blackLight;
});
var StyledLikeIcon = (0, _styledComponents["default"])(_userflow.Like).withConfig({
  displayName: "HotelOfferInfo__StyledLikeIcon",
  componentId: "sc-oi8hjh-12"
})(["position:relative;top:-2px;height:16px;margin-left:1px;"]);
var StyledFreeCancelIcon = (0, _styledComponents["default"])(_userflow.FreeCancellation).withConfig({
  displayName: "HotelOfferInfo__StyledFreeCancelIcon",
  componentId: "sc-oi8hjh-13"
})(["margin-right:4px;height:18px;"]);

var StyledFreeCancellationLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledFreeCancellationLabel",
  componentId: "sc-oi8hjh-14"
})(["display:flex;align-items:center;justify-content:center;font-size:12px;color:#0b7d58;"]);

var StyledLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelOfferInfo__StyledLabelList",
  componentId: "sc-oi8hjh-15"
})(["align-items:center;max-width:", ";overflow:hidden;"], function (props) {
  return props.isMobile ? '100%' : '140px';
});

var _default = /*#__PURE__*/_react["default"].memo(HotelOfferInfo);

exports["default"] = _default;